/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EmployeeNotificationChannel } from './EmployeeNotificationChannel';
import {
    EmployeeNotificationChannelFromJSON,
    EmployeeNotificationChannelFromJSONTyped,
    EmployeeNotificationChannelToJSON,
    EmployeeNotificationChannelToJSONTyped,
} from './EmployeeNotificationChannel';

/**
 * 
 * @export
 * @interface UpdateEmployeeNotificationChannelResponse
 */
export interface UpdateEmployeeNotificationChannelResponse {
    /**
     * 
     * @type {EmployeeNotificationChannel}
     * @memberof UpdateEmployeeNotificationChannelResponse
     */
    data: EmployeeNotificationChannel;
}

/**
 * Check if a given object implements the UpdateEmployeeNotificationChannelResponse interface.
 */
export function instanceOfUpdateEmployeeNotificationChannelResponse(value: object): value is UpdateEmployeeNotificationChannelResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function UpdateEmployeeNotificationChannelResponseFromJSON(json: any): UpdateEmployeeNotificationChannelResponse {
    return UpdateEmployeeNotificationChannelResponseFromJSONTyped(json, false);
}

export function UpdateEmployeeNotificationChannelResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateEmployeeNotificationChannelResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': EmployeeNotificationChannelFromJSON(json['data']),
    };
}

  export function UpdateEmployeeNotificationChannelResponseToJSON(json: any): UpdateEmployeeNotificationChannelResponse {
      return UpdateEmployeeNotificationChannelResponseToJSONTyped(json, false);
  }

  export function UpdateEmployeeNotificationChannelResponseToJSONTyped(value?: UpdateEmployeeNotificationChannelResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': EmployeeNotificationChannelToJSON(value['data']),
    };
}

